import React from 'react';
import useTranslations from '../useTranslations';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const Team = () => {

  const { team } = useTranslations();

  const data = useStaticQuery(graphql`
    query {
      gert: file(relativePath: { eq: "gert.jpg"}) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      harry: file(relativePath: { eq: "harry2.jpg"}) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }`)

  return (
    <>      
      <p>{team.text}</p>
      <h2>{team.subtitle}</h2>
      
      <div className="people">
        <div className="person">
        <Img className="person-img" fluid={data.gert.childImageSharp.fluid} />
          <div className="person-info">
            <h3>{team.gert.name}</h3>
            <p>{team.gert.info}</p>
          </div>
        </div>
        <div className="person">
          <Img className="person-img" fluid={data.harry.childImageSharp.fluid} />
          <div className="person-info">
            <h3>{team.harry.name}</h3>
            <p>{team.harry.info}</p>
          </div>
        </div>
      </div>
    </>

  );
}
 
export default Team;
